import { createAction } from '@reduxjs/toolkit';
export const FETCH_CALL_PARK = 'FETCH_CALL_PARK';
export const fetchCallParkAction = createAction(FETCH_CALL_PARK);